export default "__VITE_ASSET__7VM8ROlT__"